'use strict'

import { ActivityIndicator } from 'react-native'

export default ActivityIndicator
